import { observer } from "mobx-react"
import { sleep } from "polaris-enhance"
import { useState } from "react"
import {
  ActionData,
  APPEnum,
  PBAPI,
  PBPage,
  PBPageAction,
} from "react-pp-bundle"

import { PModal } from "@/components/ConfirmModal/showModal"
import stores from "@/stores"
import { isUpgrade } from "@/utils/global"
import { openCustomURL } from "@/utils/location"
import toast from "@/utils/toast"
const BundlePage = () => {
  const [btnLoading, setBtnLoading] = useState(false)
  const { PlanStore } = stores
  const { curPackageInfo } = stores.PlanStore
  const isOfficialSubscribe = PlanStore.config?.user_pkg?.source === 2

  function checkIsShowDowngradeModal(data: ActionData) {
    // 如果普通套餐切bundle套餐，视为升级
    if ((PlanStore.config?.user_pkg?.source ?? 0) < 3) return false
    // 判断是否试用期
    const isRestTrialDays = PlanStore.config?.user_pkg?.rest_trial_days
    const current = data.pbData.currentPriceInfo[APPEnum.Returns]

    const isUpgradePlan = isUpgrade(curPackageInfo, current)

    // 判断是否降级
    const isDowngrade =
      !isUpgradePlan && curPackageInfo?.id !== current?.app_plan_id
    return !isRestTrialDays && isDowngrade
  }

  return (
    <PBPage
      loading={PlanStore.bundleLoading}
      data={PlanStore.bundleData}
      setData={(v) => {
        PlanStore.setBundleData(v)
      }}
      perferPlanId={PlanStore.perferPlanId}
      perferKind={PlanStore.perferKind}
      app={APPEnum.Returns}
      period={PlanStore.bundlePeriod}
      setPeriod={(v) => {
        PlanStore.setBundlePeriod(v)
      }}
      btnDisabled={isOfficialSubscribe}
      btnLoading={btnLoading}
      onAction={async function (action: PBPageAction, data: ActionData) {
        async function updatePlan() {
          window.PB_PAGE_LOADING(true)
          setBtnLoading(true)
          const res = await PBAPI.createSubscribe({ plans: data.plans })
          if (res.code === 1000 && res.data) {
            openCustomURL(res.data.confirmation_url, false)
            await sleep(10 * 1000)
          } else {
            toast(t("OperationFailed"), 4e3, true)
          }
          setBtnLoading(false)
          window.PB_PAGE_LOADING(false)
        }
        async function resumePlan() {
          window.PB_PAGE_LOADING(true)
          setBtnLoading(true)
          const res = await PBAPI.createSubscribe({ plans: data.resumePlan })
          if (res.code === 1000 && res.data) {
            openCustomURL(res.data.confirmation_url, false)
            await sleep(10 * 1000)
          } else {
            toast(t("OperationFailed"), 4e3, true)
          }
          setBtnLoading(false)
          window.PB_PAGE_LOADING(false)
        }

        async function cancelPlan() {
          window.PB_PAGE_LOADING(true)
          setBtnLoading(true)
          const res = await PBAPI.cancelSubscribe()
          if (res.code === 1000) {
            await sleep(2 * 1000)
            await Promise.all([
              stores.CommonStore.updateAuthority(),
              stores.PlanStore.updatePlanData(),
            ])
            toast(t("DowngradedSuccessfully"), 4e3)
          } else {
            toast(t("OperationFailed"), 4e3, true)
          }
          setBtnLoading(false)
          window.PB_PAGE_LOADING(false)
        }

        // 判断升级or降级
        const actionMap = {
          async choosePlan() {
            if (isOfficialSubscribe) {
              PModal.showCWPlanModal()
              return
            }

            if (checkIsShowDowngradeModal(data)) {
              PModal.showDowngradeModal({
                package_kind:
                  data.pbData.currentPriceInfo[APPEnum.Returns].package_kind,
                onConfirm: async () => {
                  await updatePlan()
                },
              })
              return
            }
            updatePlan()
          },
          async cancelPlan() {
            // 如果是试用期，直接cancel
            if (data.data.user_pkg.trial_days_left > 0) {
              await cancelPlan()
              return
            }
            PModal.showDowngradeModal({
              package_kind:
                data.pbData.currentPriceInfo[APPEnum.Returns].package_kind,
              onConfirm: async () => {
                await cancelPlan()
              },
            })
          },
          async resumePlan() {
            await resumePlan()
          },
        }
        await actionMap[action]?.()
      }}
    />
  )
}
export default observer(BundlePage)
